import { queryOptions } from '@tanstack/react-query'

import { fetchTruckModels } from '../api/fetch-truck-models'
import { truckModelsQueryKeys } from '../query-keys'

/**
 * Select用の車種一覧のQueryOptionsを返す
 * データは全件取得
 */
export const getTruckModelsSelectQueryOptions = (
  tenantKey: string,
  dcId?: number,
  shippingDate?: string
) => {
  return queryOptions({
    queryKey: truckModelsQueryKeys.select(tenantKey, dcId, shippingDate),
    queryFn: async ({ signal }) => {
      const query = {
        enable: true,
        ...(dcId !== undefined ? { dcId } : {}),
        ...(shippingDate ? { shippingDate } : {})
      }

      // APIから全データを取得（現在の実装では上限なし）
      const { data } = await fetchTruckModels(
        {
          tenantKey,
          query
        },
        signal
      )
      return data
    }
  })
}
